<template>
  <div class="mainDiv">
    <div class="leftPart">
      <div class="countDiv">
        <!-- <p class="countText">{{currentPage}}</p> -->
      </div>
      <div>
        <!-- <button class="countbtn">25</button> -->
      </div>
      <div>
        <!-- <p class="countertext">1-25 of 250000 users</p> -->
      </div>
    </div>
    <div class="pagination">
      <div>
        <img
          src="../../../../assets/previousIcon.svg"
          alt=""
          @click="previousPage"
        />
      </div>
      <div>
        <img
          src="../../../../assets/previoustextwithIcon.svg"
          alt=""
          @click="previousPage"
        />
      </div>
      <div class="rightbuttondiv">
        <button class="countbtn" @click="nextPage">{{ currentPage }}</button>
        <!-- <p class="countertext">of {{ totalItems }}</p> -->
      </div>
      <div>
        <img
          src="../../../../assets/nextIconwithText.svg"
          alt=""
          @click="nextPage"
        />
      </div>
      <div>
        <img src="../../../../assets/nextIcon.svg" alt="" @click="nextPage" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PaginationDiv",
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 1,
      totalItems: 250000, // Replace with the actual total number of users
    };
  },
  props: {
    getUserDetails: Function,
  },
  created(){
    this.currentPage=this.$store.getters[
      "crmFilters/GET_PAGE"
    ];
    this.getUserDetails(this.currentPage);
  },
  watch: {
    '$store.state': {
      handler(newVal, oldVal) {
        // Handle state change
        console.log('State changed:', newVal, oldVal);
         this.currentPage=this.$store.getters[
      "crmFilters/GET_PAGE"
    ];
      },
      deep: true, // Watch for nested changes if applicable
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage) {
        this.currentPage++;
        this.$store.dispatch("crmFilters/setPage", this.currentPage);
        this.getUserDetails();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.$store.dispatch("crmFilters/setPage", this.currentPage);
        this.getUserDetails();
      }
    },
    getTotalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    getRangeStart() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    getRangeEnd() {
      const rangeEnd = this.currentPage * this.itemsPerPage;
      return rangeEnd > this.totalItems ? this.totalItems : rangeEnd;
    },
  },
};
</script>
<style lang="scss" scoped>
.mainDiv {
  height: 72px;

  display: flex;

  column-gap: 5%;

  border-radius: 5px;
  margin-bottom: 16px;
}
.leftPart {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 19%;
  column-gap: 2%;
}
.countText {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px;
  color: #797e79;
  margin-top: 0px;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.countDiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
.countbtn {
  background: #ffffff;
  border: 1px solid rgba(119, 119, 119, 0.5);
  border-radius: 5px;
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px 8px 16px;
  gap: 8px;

  width: 70px;
  height: 35px;
}
.countertext {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  margin-bottom: 0px;

  /* Greyscale/2 */

  color: #797e79;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  width: 76%;
  align-items: center;
}
.rightbuttondiv {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 2%;
  width: 17%;
}
</style>
